<template>
  <div>


    <div v-if="$store.state.searchShow">
      <search></search>
    </div>


    <van-nav-bar :border="false" :fixed="true">
      <template #title>
        <div class="switch">
          <div @click="goWithin" :class="$store.state.marketTitle===0?'withinOn':'within'"><span
              :class="$store.state.marketTitle===0?'withinTextOn':'withinText'">内盘</span></div>
          <div @click="goOutside" :class="$store.state.marketTitle===1?'outsideOn':'outside'"><span
              :class="$store.state.marketTitle===1?'outsideTextOn':'outsideText'">外盘</span></div>
          <div @click="goTheme" :class="$store.state.marketTitle===2?'themeOn':'theme'"><span
              :class="$store.state.marketTitle===2?'themeTextOn':'themeText'">主题</span></div>

        </div>

      </template>
      <template #right>
        <div @click="$store.state.menuOpen = false;$store.state.menuShow = false;$store.state.searchShow=true;">
          <svg-icon icon-class="search" style="width:20px;height:20px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>


    <!--&lt;!&ndash;    <div v-show="$store.state.marketTitle"><information></information></div>&ndash;&gt;-->
    <!--&lt;!&ndash;    <div v-show="!$store.state.marketTitle"><strategy-list></strategy-list></div>&ndash;&gt;-->

    <div v-show="!$store.state.searchShow">
      <div v-if="$store.state.searchLock">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>


import search from "@/components/search/search";

export default {
  name: "marketTitle",
  components: {search},
  data() {
    return {}
  },
  methods: {
    goWithin() {
      if (this.$route.path !== '/market/within') {
        if (this.$store.state.marketLock[1]){
          for (let i = 0; i < this.$store.state.marketLock[1].length; i++) {
            this.$store.state.marketLock[1][i]=false
          }
        }
        if (this.$store.state.marketLock[2]){
          for (let j = 0; j < this.$store.state.marketLock[2].length; j++) {
            this.$store.state.marketLock[2][j]=false
          }
        }
        this.$router.push('/market/within');
        this.$store.state.marketTitle = 0;
      }
    },
    goOutside() {
      if (this.$route.path !== '/market/outside') {
        if (this.$store.state.marketLock[0]){
          for (let i = 0; i < this.$store.state.marketLock[0].length; i++) {
            this.$store.state.marketLock[0][i]=false
          }
        }
        if (this.$store.state.marketLock[2]){
          for (let j = 0; j < this.$store.state.marketLock[2].length; j++) {
            this.$store.state.marketLock[2][j]=false
          }
        }
        this.$router.push('/market/outside');
        this.$store.state.marketTitle = 1;
      }
    },
    goTheme() {
      if (this.$route.path !== '/market/theme') {
        if (this.$store.state.marketLock[0]){
          for (let i = 0; i < this.$store.state.marketLock[0].length; i++) {
            this.$store.state.marketLock[0][i]=false
          }
        }
        if (this.$store.state.marketLock[1]){
          for (let j = 0; j < this.$store.state.marketLock[1].length; j++) {
            this.$store.state.marketLock[1][j]=false
          }
        }
        this.$router.push('/market/theme');
        this.$store.state.marketTitle = 2;
      }
    },
    checkUrl() {
      if (this.$store.state.marketTitle === 0) {
        this.$router.push('/market/within');
      } else if (this.$store.state.marketTitle === 1) {
        this.$router.push('/market/outside');
      } else if (this.$store.state.marketTitle === 2) {
        this.$router.push('/market/theme');
      }
    },
    getMenu() {
      this.$get(this.$store.state.marketApiUrl + "/api/symbol/quoteCategory").then(res => {
        this.$store.state.marketMenu = res
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            this.$store.state.marketLock[i] = []
            for (let j = 0; j < res.data[i].categorys.length; j++) {
              this.$store.state.marketLock[i][j] = false
            }
          }
        }


      }).catch(err => {
        console.log(err)
      })
    },
  },
  created() {
    this.checkUrl()
    this.getMenu()
  }
}
</script>

<style scoped>
.switch {
  display: flex;

}

.within {
  width: 55px;
  height: 28px;
  color: #93a2b8;
  border: 1px solid;
  border-right: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.withinOn {
  width: 55px;
  height: 28px;
  color: #1875f8;
  background-color: #1875f8;
  border: 1px solid;
  border-right: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}


.outside {
  width: 55px;
  height: 28px;
  color: #93a2b8;
  border: 1px solid;
  border-left: 0;
  border-right: 0;

}

.outsideOn {
  width: 55px;
  height: 28px;
  color: #1875f8;
  background-color: #1875f8;
  border: 1px solid;
  border-left: 0;
  border-right: 0;


}

.theme {
  width: 55px;
  height: 28px;
  color: #93a2b8;
  border: 1px solid;
  border-left: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

}

.themeOn {
  width: 55px;
  height: 28px;
  color: #1875f8;
  background-color: #1875f8;
  border: 1px solid;
  border-left: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

}


.withinText {
  line-height: 30px;
  margin: 0 12px;
}

.withinTextOn {
  line-height: 30px;
  color: white;
  margin: 0 12px;
  font-weight: bolder;

}

.outsideText {
  line-height: 30px;
  margin: 0 12px;
}

.outsideTextOn {
  line-height: 30px;
  color: white;
  margin: 0 12px;
  font-weight: bolder;
}

.themeText {
  line-height: 30px;
  margin: 0 12px;
}

.themeTextOn {
  line-height: 30px;
  color: white;
  margin: 0 12px;
  font-weight: bolder;
}


</style>
